import React, { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import "../css/Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await addDoc(collection(db, "contacts"), {
        name: formData.name,
        email: formData.email,
        subject: formData.subject,
        message: formData.message,
        submittedAt: new Date(),
      });

      alert("Message sent successfully! We will get back to you soon.");
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (error) {
      alert("Error sending message: " + error.message);
    }
    setLoading(false);
  };

  return (
    <div className="contact-page">
      <div className="contact-hero">
        <h1>Contact Us</h1>
        <p>Any questions or remarks? Just write us a message!</p>
      </div>

      <div className="contact-container">
        <div className="contact-info-grid">
          <div className="info-item">
            <div className="icon-circle">📍</div>
            <h3>Our Address</h3>
            <p>
              Sahara Public Secondary School
              <br />
              Krishna Nagar Municipality- Ward No. 01, District: Kapilvastu,
              <br /> Provine: Lumbini, Nepal
            </p>
          </div>
          <div className="info-item">
            <div className="icon-circle">📞</div>
            <h3>Contact Number</h3>
            <p>
              +977-984-7040404
              <br />
              +977-76-520102
            </p>
          </div>
          <div className="info-item">
            <div className="icon-circle">✉️</div>
            <h3>Email Address</h3>
            <p>
              info@sahara.edu.np
              <br />
              admissions@sahara.edu.np
            </p>
          </div>
          <div className="info-item">
            <div className="icon-circle">⏰</div>
            <h3>Working Hours</h3>
            <p>
              Monday - Friday: 9:00 AM - 3:00 PM
              <br />
              Saturday & Sunday: Closed
            </p>
          </div>
        </div>

        <div className="contact-main-wrapper">
          <div className="contact-form-box">
            <h2>Send us a Message</h2>
            <form onSubmit={handleSubmit}>
              <div className="input-row">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                required
                value={formData.subject}
                onChange={handleChange}
              />
              <textarea
                name="message"
                rows="6"
                placeholder="Write your message here..."
                required
                value={formData.message}
                onChange={handleChange}
              ></textarea>
              <button type="submit" className="primary-btn" disabled={loading}>
  {loading ? "Sending..." : "Send Message"}
</button>
               
            </form>
          </div>

          <div className="contact-map">
            <iframe
              src="https://maps.google.com/maps?q=/Shivanagar+32800,+Nepal&t=&z=13&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0, borderRadius: "15px" }}
              allowFullScreen=""
              loading="lazy"
              title="Sahara Map Location"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
